import httpStore from "@/api/httpStore.js";
import decamelizeKeysDeep from "decamelize-keys-deep";

export function getBrands() {
  return httpStore
    .get("brands")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getNewBrands() {
  return httpStore
    .get("brands/get_brands_from_parts")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function updateBrand(brandId, newBrand) {
  newBrand = decamelizeKeysDeep(newBrand);
  return httpStore
    .put(`brands`, {
      id: brandId,
      newBrand: newBrand
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function createBrand(newBrand) {
  newBrand = decamelizeKeysDeep(newBrand);
  return httpStore
    .post(`brands`, {
      newBrand: newBrand
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function requestDeleteBrand(id) {
  return httpStore
    .delete(`brands?id=${id}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return {
        status: "error",
        message: e.response?.data?.message || e.message
      };
    });
}
